import { USER_SUCCESS, USER_LOGOUT } from '../actions/user'

const state = {
  userPk : localStorage.getItem('airspirit-user-pk') || '',
  userCompanyPk : localStorage.getItem('airspirit-user-company_pk') || '',
  userGroups: localStorage.getItem('airspirit-user-group') || '',
  userFirstName: localStorage.getItem('airspirit-user-first_name') || '',
  userLastName: localStorage.getItem('airspirit-user-last_name') || '',
  userUsername: localStorage.getItem('airspirit-user-username') || '',
}

const getters = {
  getUserPk: state => state.userPk,
  getUserCompanyPk: state => state.userCompanyPk,
  getUserGroups: state => state.userGroups,
  getUserFirstName: state => state.userFirstName,
  getUserLastName: state => state.userLastName,
  getUserUsername: state => state.userUsername,

}

const actions = {
  [USER_LOGOUT]: ({commit}) => {
    commit(USER_LOGOUT)
  }
}

const mutations = {
  [USER_SUCCESS]: (state, resp) => {
    console.log(resp)
    state.status = 'success'
    state.userPk = resp.id
    localStorage.setItem('airspirit-user-pk', resp.id)
    state.userCompanyPk = resp.company_pk
    localStorage.setItem('airspirit-user-company_pk', resp.company_pk)
    state.userGroups = JSON.stringify(resp.groups)
    localStorage.setItem('airspirit-user-group', JSON.stringify(resp.groups))
    state.userFirstName = resp.first_name
    localStorage.setItem('airspirit-user-first_name', resp.first_name)
    state.userLastName = resp.last_name
    localStorage.setItem('airspirit-user-last_name', resp.last_name)
    state.userUsername = resp.username
    localStorage.setItem('airspirit-user-username', resp.username)

  },
  [USER_LOGOUT]: (state) => {
    state.userPk = ''
    localStorage.removeItem('airspirit-user-pk')
    state.userCompanyPk = ''
    localStorage.removeItem('airspirit-user-company_pk')
    state.userGroups = ''
    localStorage.removeItem('airspirit-user-group')
    state.userFirstName = ''
    localStorage.removeItem('airspirit-user-first_name')
    state.userLastName = ''
    localStorage.removeItem('airspirit-user-last_name')
    state.userUsername = ''
    localStorage.removeItem('airspirit-user-username')
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
